import {
  MQ_SMALL_ONLY,
  MQ_MEDIUM_DOWN,
  MQ_MIDLARGE,
  MQ_LARGE,
  MQ_MEDIUM
} from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base3x2, large3x2, medium3x2, small3x2 } = IMAGE_SIZES;

const base = {
  fallbackDims: base3x2,
  sourceSets: [
    {
      layoutWidth: { value: 198, units: 'px' },
      imageDims: medium3x2,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 162, units: 'px' },
      imageDims: medium3x2,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 240, units: 'px' },
      imageDims: medium3x2,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 320, units: 'px' },
      imageDims: small3x2,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: '(min-width: 0px)',
      ratio: 3 / 2
    }
  ]
};

const exceptionPatterns = [
  {
    positionStart: 0,
    recurrence: 5,
    fallbackDims: base3x2,
    sourceSets: [
      {
        layoutWidth: { value: 656, units: 'px' },
        imageDims: large3x2,
        media: MQ_MIDLARGE
      },
      {
        layoutWidth: { value: 556, units: 'px' },
        imageDims: large3x2,
        media: MQ_LARGE
      },
      {
        layoutWidth: { value: 720, units: 'px' },
        imageDims: large3x2,
        media: MQ_MEDIUM
      },
      {
        layoutWidth: { value: 320, units: 'px' },
        imageDims: small3x2,
        media: MQ_SMALL_ONLY
      }
    ],
    placeholders: [
      {
        media: MQ_LARGE,
        ratio: 3 / 2
      },
      {
        media: `${MQ_MEDIUM} and ${MQ_MEDIUM_DOWN}`,
        ratio: 3 / 2
      },
      {
        media: MQ_SMALL_ONLY,
        ratio: 3 / 2
      }
    ]
  },
  {
    positionStart: 1,
    recurrence: 5,
    fallbackDims: base3x2,
    sourceSets: [
      {
        layoutWidth: { value: 656, units: 'px' },
        imageDims: large3x2,
        media: MQ_MIDLARGE
      },
      {
        layoutWidth: { value: 556, units: 'px' },
        imageDims: large3x2,
        media: MQ_LARGE
      },
      {
        layoutWidth: { value: 720, units: 'px' },
        imageDims: large3x2,
        media: MQ_MEDIUM
      },
      {
        layoutWidth: { value: 320, units: 'px' },
        imageDims: small3x2,
        media: MQ_SMALL_ONLY
      }
    ],
    placeholders: [
      {
        media: MQ_LARGE,
        ratio: 3 / 2
      },
      {
        media: `${MQ_MEDIUM} and ${MQ_MEDIUM_DOWN}`,
        ratio: 3 / 2
      },
      {
        media: MQ_SMALL_ONLY,
        ratio: 3 / 2
      }
    ]
  }
];

export default {
  base,
  exceptionPatterns
};
